import { render, staticRenderFns } from "./sendEmail.vue?vue&type=template&id=414d0fb7"
import script from "./sendEmail.vue?vue&type=script&lang=js"
export * from "./sendEmail.vue?vue&type=script&lang=js"
import style0 from "./sendEmail.vue?vue&type=style&index=0&id=414d0fb7&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('414d0fb7')) {
      api.createRecord('414d0fb7', component.options)
    } else {
      api.reload('414d0fb7', component.options)
    }
    module.hot.accept("./sendEmail.vue?vue&type=template&id=414d0fb7", function () {
      api.rerender('414d0fb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/sendEmail.vue"
export default component.exports